module.exports = __webpack_public_path__ + "static/media/Comoros.c976cb85.png";